/**
 * Single switch for the mock backend.
 *
 * Kept in its own module so both the app entry point and `realtimeService` can
 * read it without importing the whole mock bundle — the fixtures and handlers
 * are only pulled in behind a dynamic import when the flag is on, so a
 * production build tree-shakes them out entirely.
 */

function envFlag(value: string | boolean | undefined): boolean | undefined {
  if (value === undefined || value === '') return undefined;
  // Windows CRLF can leave a trailing `\r` on `.env` values; trim before compare.
  const normalised = String(value).trim().toLowerCase();
  if (normalised === 'true' || normalised === '1') return true;
  if (normalised === 'false' || normalised === '0') return false;
  return undefined;
}

/**
 * Mock is on when `VITE_USE_MOCK_API=true`.
 *
 * In `npm run dev` it is also the default: this repo ships no NestJS process,
 * so a forgotten env flag previously sent login to Vite's proxy, which answered
 * with a 500 HTML page ("Errore interno del server") the moment `:3000` refused.
 * Set `VITE_USE_MOCK_API=false` to talk to a real backend.
 */
export function isMockApiEnabled(): boolean {
  const explicit = envFlag(import.meta.env.VITE_USE_MOCK_API);
  if (explicit !== undefined) return explicit;
  return import.meta.env.DEV;
}
